import { render, staticRenderFns } from "./MyAliceActionDialog.vue?vue&type=template&id=6f90190e"
import script from "./MyAliceActionDialog.vue?vue&type=script&lang=js"
export * from "./MyAliceActionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports